import firebase from "./firebaseConfig";
import api from "./api";

const APPNAME_HEADER = {
  headers: {
    appname: "tupinamba",
  },
};

export const ONBOARDING_ORIGIN = {
  ADMIN: "admin",
  CPMS: "cpms",
};

/**
 * Executa o fluxo de autosserviço de cadastro:
 * 1. Cria user no Firebase Auth.
 * 2. Atualiza displayName no Firebase.
 * 3. Envia email de verificação.
 * 4. Faz upsert no Mongo via PUT /user/:uid (usa o token Firebase recém-emitido).
 * 5. Se keepSession=false (padrão), desloga — o user aguarda aprovação manual.
 *    Se keepSession=true (fluxo WeMob), mantém a sessão para continuar o wizard.
 *
 * Em qualquer erro, sempre desloga antes de propagar a exceção.
 */
export async function signUp({ email, password, displayName, onboardingOrigin, keepSession = false }) {
  const credential = await firebase
    .auth()
    .createUserWithEmailAndPassword(email, password);

  const user = credential.user;

  try {
    await user.updateProfile({ displayName });

    try {
      await user.sendEmailVerification();
    } catch (err) {
      // Falha no email de verificação não deve bloquear o cadastro.
      console.warn("sendEmailVerification failed:", err);
    }

    try {
      await api.put(
        `/user/${user.uid}`,
        {
          displayName,
          email,
          newsLetter: true,
          creation_method: "email_and_password",
          onboarding_origin: onboardingOrigin,
        },
        APPNAME_HEADER
      );
    } catch (err) {
      console.error("Failed to upsert user in Mongo:", err);
      const inconsistent = new Error("MONGO_UPSERT_FAILED");
      inconsistent.email = email;
      inconsistent.cause = err;
      throw inconsistent;
    }
  } catch (err) {
    await firebase.auth().signOut();
    throw err;
  }

  if (!keepSession) {
    await firebase.auth().signOut();
  }

  return user.uid;
}
